export const MAPBOX_TOKEN = process.env.GATSBY_MAPBOX_ACCESS_TOKEN

export const MAPBOX_STYLE_URL =
  'mapbox://styles/hawaiinationalbank/ckdrrbubo08og19o4l7oxhkb3'
